import { render, staticRenderFns } from "./editUserGroup.vue?vue&type=template&id=4cd8f82d&scoped=true&"
import script from "./editUserGroup.vue?vue&type=script&lang=js&"
export * from "./editUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./editUserGroup.vue?vue&type=style&index=0&id=4cd8f82d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd8f82d",
  null
  
)

export default component.exports